import api from '@/configs/ApiConfig';
const User = () => import(/*webpackChunkName: "user"*/ '@/views/administration/user/User.vue');

const Role = () => import(/*webpackChunkName: "company"*/ '@/views/administration/role/Role.vue');

const UserRoleLink = () => import(/*webpackChunkName: "user"*/ '@/views/administration/userRoleLink/UserRoleLink.vue');

const RolePolicyLink = () =>
    import(/*webpackChunkName: "user"*/ '@/views/administration/rolePolicyLink/RolePolicyLink.vue');

const Company = () => import(/*webpackChunkName: "company"*/ '@/views/administration/company/Company.vue');

const AdminUser = () => import(/*webpackChunkName: "user"*/ '@/views/administration/adminUser/AdminUser.vue');

const Logging = () => import(/*webpackChunkName: "logging"*/ '@/views/administration/logging/Logging.vue');

export default [
    {
        name: 'user',
        path: api.administration.user,
        component: User,
    },
    {
        name: 'role',
        path: api.administration.role,
        component: Role,
    },
    {
        name: 'userRoleLink',
        path: api.administration.userRoleLink,
        component: UserRoleLink,
    },
    {
        name: 'rolePolicyLink',
        path: api.administration.rolePolicyLink,
        component: RolePolicyLink,
    },
    {
        name: 'company',
        path: api.administration.company,
        component: Company,
    },
    {
        name: 'adminUser',
        path: api.administration.adminUser,
        component: AdminUser,
    },
    {
        name: 'logging',
        path: api.administration.logging,
        component: Logging,
    },
];
